var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("path", {
    attrs: {
      "fill-rule": "evenodd",
      d:
        "M74.866 1.444C66.123 1.227 25.09-4.128 12.223 9.37-.606 22.826-3.745 50.184 7.925 60.667 19.595 71.15 57.92 68.7 68.213 68.955c6.72.167 43.363-1.366 56.433-11.219 9.18-6.92 11.849-21.03 4.524-36.42C121.752 2.395 80.784 1.59 74.866 1.443z"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7f0c2dcc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f0c2dcc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/_SVG/ShapeYearBtn1Mob.vue
// module id = Zei1
// module chunks = 1